import { useQuery } from "@tanstack/react-query";

import { getPartnersSupervisorSearch } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PARTNERS_QUERY_KEYS } from "./queryKeys";

const DEFAULT_LIMIT = 1000;

export function useSuperiorPartnersQuery(enabled = true) {
  return useQuery({
    queryKey: PARTNERS_QUERY_KEYS.supervisorSearch,
    queryFn: processResponse(() =>
      getPartnersSupervisorSearch(0, DEFAULT_LIMIT),
    ),
    enabled,
  });
}
